import React from 'react';
import PropTypes from 'prop-types';
import { watermarkType } from '@molecules/Watermark/prop-types';
import TranscriptPage from '@layout/TranscriptPage';
import { TRANSCRIPT_VIEW_TYPES } from '@config/transcriptViewConfig';
import { TranscriptContents, TranscriptTitle, Disclaimer, Watermark } from '@molecules';
import { DiscussionPoints } from '@organisms';

export const Transcript = ({
  conference: { title, date, discussionPoints: conversations },
  watermark,
  mode,
}) => (
  <TranscriptPage.Container className="transcript-container">
    <div className="page-break-avoid">
      {watermark && <Watermark watermark={watermark} />}
      <TranscriptTitle title={title} date={date} />
      <Disclaimer />
    </div>
    <TranscriptContents />
    {mode !== TRANSCRIPT_VIEW_TYPES.CLIENT_PREVIEW &&
      conversations &&
      conversations.map((conversation) => (
        <DiscussionPoints
          key={conversation.conversationId}
          monologues={conversation.monologues}
        />
      ))}
  </TranscriptPage.Container>
);

Transcript.propTypes = {
  token: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  conference: PropTypes.shape({
    title: PropTypes.string,
    date: PropTypes.string,
    discussionPoints: PropTypes.array,
  }),
  watermark: PropTypes.oneOfType([watermarkType, PropTypes.bool]),
  mode: PropTypes.oneOf([
    TRANSCRIPT_VIEW_TYPES.FULL,
    TRANSCRIPT_VIEW_TYPES.ADMIN_PREVIEW,
    TRANSCRIPT_VIEW_TYPES.CLIENT_PREVIEW,
  ]).isRequired,
};



// WEBPACK FOOTER //
// ./components/templates/TranscriptView/Transcript.js